export const cibYCombinator = ["32 32","<path d='M30 2v28h-28v-28zM16.75 17.969l4.844-9.094h-2.044l-2.863 5.688c-0.294 0.581-0.563 1.144-0.8 1.675l-0.762-1.675-2.825-5.688h-2.188l4.794 8.988v5.906h1.844z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-y-combinator.js
// module id = null
// module chunks = 